var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3584,
    cy: 13.0664,
    r: 12.5439,
    stroke: "#22D5D5",
    strokeWidth: 0.912148
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51685 5.35547L10.0604 13.0661L6.51685 20.7767L20.1991 13.0661L6.51685 5.35547ZM8.68238 7.71787L17.3117 12.5739H10.9135L8.68238 7.71787ZM10.9135 13.5582H17.3117L8.68238 18.4143L10.9135 13.5582Z",
    fill: "#22D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendRating);
export default __webpack_public_path__ + "static/media/send-rating.455eba9b8199233d076a53c7a54c10d6.svg";
export { ForwardRef as ReactComponent };